import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'react-proptypes';
import { currencyFormatter } from '@dnhb/formatters';
import { dispatchMapper } from '../../../shared/wizard/actions';
import { shapeOutput, shapeInput, shapeSettings } from '../config';
import getRepaymentString from '../../../shared/helpers/repaymentMonthsToString';
import SavingsSvg from 'images/shared/savings.svg';

class OutputResults extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { sync, output, input, settings } = this.props;
    const repaymentString = getRepaymentString(output.total_months);

    return (
      <div className="results">
        <div className="result-content">
          <p>
            U gaat per maand een bedrag van&nbsp;
            <strong>
              { currencyFormatter(input.monthly_payment) }
            </strong>
            &nbsp;aflossen
            <br />
            daarmee lost u na&nbsp;
            <strong>
              { repaymentString }
            </strong>
            &nbsp;een bedrag van&nbsp;
            <strong>
              { currencyFormatter(input.amount) }
            </strong>
            &nbsp;af.
          </p>
        </div>
        <div className="result-timeline">
          <h2>Besparing tijdlijn</h2>
          {(output.timeline || []).map(period => (
            <div className={period.months_passed ? '' : 'heading'} key={period.months_passed}>
              <div className="first-column">
                {
                  period.months_passed
                    ? `Na ${getRepaymentString(period.months_passed)}`
                    : <SavingsSvg />
                }
              </div>
              <div>
                {period.months_passed ? <span>Rentelasten</span> : (
                  <span>
                    Huidige
                    <br />
                    rentelast
                  </span>
                )}
                <strong>{currencyFormatter(period.interest_payment)}</strong>
              </div>
              <div>
                {period.months_passed ? <span>Maandlasten</span> : (
                  <span>
                    Huidige
                    <br />
                    maandlast
                  </span>
                )}
                <strong>{currencyFormatter(period.monthly_payment)}</strong>
              </div>
            </div>
          ))}
        </div>
        {settings.enableDisclaimer && (
          <footer className="no-mobile">
            <button type="button" onClick={() => sync('show_disclaimer', true)}>Disclaimer</button>
          </footer>
        )}
      </div>
    );
  }
}

OutputResults.propTypes = {
  sync: PropTypes.func.isRequired,
  output: shapeOutput.isRequired,
  input: shapeInput.isRequired,
  settings: shapeSettings.isRequired,
};

OutputResults.defaultProps = {};

export default connect(state => ({
  output: state.output,
  input: state.input,
  settings: state.settings,
}), dispatchMapper)(OutputResults);
